<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg px-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0 z-50 bg-white pt-5">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="w-3/5 mx-auto">
          <div
            v-for="comment in comments"
            :key="comment.id"
            class="relative flex flex-col mb-4 px-4 py-2 bg-gray-200 rounded-lg shadow-lg"
          >
            <div class="flex flex-col">
              <div
                v-if="comment.usuario_id === uuid"
                class="w-full text-left text-xs text-gray-800"
              >
                {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }} yo
              </div>
              <div
                v-if="comment.usuario_id === uuid"
                class="w-full text-left text-gray-700"
              >
                {{ comment.texto }}
              </div>
              <div
                v-if="comment.usuario_id !== uuid && is_curador == true"
                class="w-full text-right text-xs text-gray-800"
              >
                usuario {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }}
              </div>
              <div
                v-if="comment.usuario_id !== uuid && is_curador == false"
                class="w-full text-right text-xs text-gray-800"
              >
                verificador {{ comment.fecha_hora | moment("DD/MM/YYYY hh:mm a") }}
              </div>
              <div
                v-if="comment.usuario_id !== uuid"
                class="w-full text-right text-gray-700"
              >
                {{ comment.texto }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex w-full sticky bottom-0 justify-center py-5 bg-white">
          <button
            v-on:click="updateStatusModal()"
            class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
          >
            Enviar Mensaje
          </button>
        </div>
      </div>
    </div>

    <user-raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllChat="fetchAllChat"
    ></user-raising-modal>
  </div>
</template>

<script>
import UserRaisingModal from "./UserRaisingModal";
import EventBus from "../event-bus";

export default {
  name: "raising-chat-modal",
  data() {
    return {
      uuid: localStorage.getItem("user_id"),
      is_curador: false,
      information: null,
      comments: null,
      showRaisingModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      maxStars: 5,
      filter: "all",
    };
  },
  components: {
    UserRaisingModal,
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  mounted() {
    EventBus.$on("showChatModal", this.setData);
  },
  methods: {
    reset() {
      this.is_curador = false;
      this.information = null;
      this.errors = {
        codeError: "Ha ocurrido un error",
      };
      this.showingError = false;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(data) {
      this.information = Object.assign({}, data);
      this.is_curador = this.information.is_curador;
      if (this.information.menu == "LEVANTAMIENTO") {
        this.fetchCommentsRaising();
      } else {
        this.fetchCommentsProyects();
      }
    },
    fetchCommentsProyects() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          `../apidev/projects/getComments`,
          {
            id: this.information.raising_id,
          },
          this.config
        )
        .then((response) => {
          this.comments = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    fetchCommentsRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post(
          `../apidev/levantamientos/getComments`,
          {
            id: this.information.raising_id,
          },
          this.config
        )
        .then((response) => {
          this.comments = response.data;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    updateStatusModal() {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", this.information);
    },
    fetchAllChat() {
      if (this.information.menu == "LEVANTAMIENTO") {
        this.fetchCommentsRaising();
      } else {
        this.fetchCommentsProyects();
      }
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
